<div class="page-404-wrapper">
    <div class="page-404">
        <h1>{{errorCode}}</h1>
        <p>{{errorMessage}}</p>
    </div>
</div>
